import { Component } from '@angular/core';
import { AuthResponseData } from 'src/app/shared/models/authentication/auth-response-data';
import { IEmployee } from 'src/app/shared/models/employee/employee.model';
import { MenuService } from '../menu/menu.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  RIGHT_FOOTER_TEXT: string;
  showUpdateChecker : boolean = false;
  authResponseData: AuthResponseData;
  enableIntegrationServer : boolean = false;
  public employee: IEmployee;
  private subscriptions: Subscription[] = [];
  constructor( public menuService: MenuService) {
    this.RIGHT_FOOTER_TEXT="&copy; | {{year}} Nexus/Schauf GmbH";
    this.RIGHT_FOOTER_TEXT=this.RIGHT_FOOTER_TEXT.replace("{{year}}", new Date().getFullYear().toString());
    this.authResponseData = JSON.parse(localStorage.getItem('AppointmentManagementUser'));
    if(this.authResponseData.userRoles.includes("UpdateChecker.View")){
      this.showUpdateChecker = true;
    }
    else{
      this.showUpdateChecker = false;
    }
    this.subscriptions.push(this.menuService.getEnableIntegrationServer().subscribe(result =>
    {
      this.enableIntegrationServer = result;
    }));
  }

  get_right_footer_text()
  {
      return this.RIGHT_FOOTER_TEXT;
  }
}
